import React from 'react';
import { Button } from '../ui/button';
import { Trash2, GripVertical, ExternalLink, Edit2 } from 'lucide-react';
import { sanitizeEmbed } from '../../lib/sanitizeEmbed';

export const LinkedInPostCard = ({ post, index, onEdit, onDelete }) => (
  <div className="border rounded-lg p-4 bg-white" data-testid={`linkedin-post-${index}`} data-post-id={post._id}>
    <div className="flex items-start justify-between mb-3">
      <div className="flex items-center gap-2">
        <GripVertical className="w-4 h-4 text-gray-400" />
        <div>
          <h4 className="font-medium text-gray-900">{post.title || `Post ${index + 1}`}</h4>
          {post.linkedinUrl && (
            <a href={post.linkedinUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-blue-600 hover:underline flex items-center gap-1">
              View on LinkedIn <ExternalLink className="w-3 h-3" />
            </a>
          )}
        </div>
      </div>
      <div className="flex gap-1">
        <Button variant="ghost" size="sm" onClick={onEdit} data-testid={`edit-linkedin-post-${post._id}`}>
          <Edit2 className="w-4 h-4" />
        </Button>
        <Button variant="ghost" size="sm" className="text-red-600 hover:text-red-700 hover:bg-red-50" onClick={onDelete} data-testid={`delete-linkedin-post-${post._id}`}>
          <Trash2 className="w-4 h-4" />
        </Button>
      </div>
    </div>
    <div className="bg-gray-100 rounded p-2 overflow-hidden">
      <div className="linkedin-embed-preview" dangerouslySetInnerHTML={{ __html: sanitizeEmbed(post.embedCode) }} style={{ maxWidth: '100%', overflow: 'hidden' }} />
    </div>
  </div>
);
